import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {
    Grid,
    IconButton
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CloseIcon from '@material-ui/icons/Close';
import { getDateInStringDDMMMYYYY, numberFormat } from '../../../utils/utils';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    infoDialogTitle: {
        '& .MuiTypography-root ': {
            color: '#0033cc',
            fontWeight: 600,
            fontSize: 18,
            textTransform: 'capitalize'
        }
    },
    closeButton: {
        color: '#0b1323',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: 14,
        opacity: 0.5
    },
    dialogTitleV1: {
        paddingLeft: '24px !important',
        paddingRight: '12px !important',
        paddingTop: '12px !important',
        paddingBottom: '0px !important',
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },
    titleV1: {
        fontSize: 20,
        color: '#0b1323',
        fontWeight: 'bold'
    },
    closeIcon: {
        color: '#D5D6D9',
        fontSize: 24
    },
    brV1: {
        borderRadius: '8px !important'
    },
    widthV1: {
        width: 437,
        maxWidth: 437,
        minWidth: 437
    },
    dialogContentV1: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 12,
        paddingBottom: '24px !important'
    },
    gridContainer: {
        borderRadius: '8px',
        backgroundColor: '#f1f3f6',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        paddingBottom: 12
    },
    divAlignV1: {
        display: 'flex',
        alignItems: 'center'
    },
    divAlignV2: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 10
    },
    textV1: {
        fontWeight: 600,
        color: '#0b1323'
    },
    arrowIcon: {
        color: '#6d717b',
        fontSize: 22,
        marginLeft: 2,
        marginRight: 2
    },
    tripDate: {
        fontSize: '12px',
        color: '#6d717b'
    },
    circleIcon: {
        color: '#c7c7c7',
        fontSize: 8,
        marginLeft: 4,
        marginRight: 4
    },
    divVehicleNumber: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        color: '#0b1323'
    },
    mlV1: {
        marginLeft: 4
    },
    mtV2: {
        marginTop: 20
    },
    mtV1: {
        marginTop: 16
    },
    hrV1: {
        borderTop: '1px dashed #c6c6c6',
        marginTop: 16
    },
    mtV3: {
        marginTop: 8
    },
    titleV2: {
        fontWeight: 600,
        color: '#0b1323'
    },
    titleV3: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#0b1323'
    },
    textV2: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#0033cc'
    }

}));

export default function InvoiceTripInfoDialog(props) {

    const { open, onClose, tripData } = props;
    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    return (
        <>
            <Dialog
                open={dialogOpen}
                className={classes.infoDialog}
                maxWidth='xs'
                TransitionComponent={Transition}
                onClose={handleClose}
                aria-labelledby="InvoiceTripInfoDialog-dialog-slide-title"
                aria-describedby="InvoiceTripInfoDialog-dialog-slide-description"
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                classes={{ paperScrollPaper: classes.brV1, paperWidthXs: classes.widthV1 }}
            >
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divAlign}>
                        <div className={classes.titleV1}>Invoice Amount Details</div>
                        <div>
                            <IconButton onClick={handleClose}>
                                <CloseIcon className={classes.closeIcon} />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent className={classes.dialogContentV1}>

                    <Grid
                        container
                        justifyContent="space-between"
                        wrap="nowrap"
                        direction="column"
                        className={classes.gridContainer}
                    >

                        <div className={classes.divAlignV1} >
                            <div className={classes.textV1}>{tripData && tripData.startLocation ? tripData.startLocation : ""}</div>
                            <ArrowRightIcon className={classes.arrowIcon} />
                            <div className={classes.textV1}>{tripData && tripData.destinationLocation ? tripData.destinationLocation : ""}</div>
                        </div>

                        <div className={classes.divAlignV2}>
                            <div className={classes.tripDate}>{tripData && tripData.startDate ? getDateInStringDDMMMYYYY(tripData.startDate) : ""}</div>
                            <FiberManualRecordIcon className={classes.circleIcon} />
                            <div className={classes.divVehicleNumber}>
                                {tripData && tripData.vehicleNumArray && tripData.vehicleNumArray.length > 0 && tripData.vehicleNumArray.map((vehicleNumber, index) => (
                                    <div className={index != 0 ? classes.mlV1 : ""}>
                                        {vehicleNumber}
                                    </div>
                                ))}
                            </div>
                        </div>

                    </Grid>

                    <div className={classes.mtV2}>

                        <Grid
                            container
                            wrap="nowrap"
                            justify="space-between"
                        >
                            <Grid item className={classes.titleV2}>Freight Amount</Grid>
                            <Grid item>{numberFormat(tripData && tripData.freight ? tripData.freight : 0)}</Grid>
                        </Grid>

                        <Grid
                            container
                            wrap="nowrap"
                            justify="space-between"
                            className={classes.mtV1}
                        >
                            <Grid item>Total Charges</Grid>
                            <Grid item>{numberFormat(tripData && tripData.charges ? tripData.charges : 0)}</Grid>
                        </Grid>

                        <Grid
                            container
                            wrap="nowrap"
                            justify="space-between"
                            className={classes.mtV1}
                        >
                            <Grid item>Total Deductions</Grid>
                            <Grid item>{numberFormat(tripData && tripData.deductions ? tripData.deductions : 0)}</Grid>
                        </Grid>
                    </div>

                    <hr className={classes.hrV1} />

                    <Grid
                        container
                        wrap="nowrap"
                        justify="space-between"
                        className={classes.mtV3}
                    >
                        <Grid item className={classes.titleV3}>Invoice Amount</Grid>
                        <Grid item className={classes.textV2}>{numberFormat(tripData && tripData.balance ? tripData.balance : 0)}</Grid>
                    </Grid>

                </DialogContent>
            </Dialog>
        </>
    )

}